import type { AxiosInstance } from 'axios';

import type { CustomErrorInterceptor } from './localApiAxiosErrorInterceptors';

import { appConfig } from '../../../../appConfig';
import { trimTrailingSlash } from '../../utils/stringUtils';
import axiosClientFactory from './clientFactory';

export type ApiLoyaltyException = {
    errorCode: number;
    status: string;
};
export type ApiLoyaltyMember20Exception = {
    title: string;
    status: number;
    detail: string;
};
export type ApiHouseholdMemberException = {
    title: string;
    status: number;
    detail: string;
    error: string;
};

export const externalLoyaltyAccountApiUrlPrefix = 'loyalty/account';

const getDirectLoyaltyAxiosClient = <TApiError = unknown>(
    accessToken: string,
    errorInterceptors?: CustomErrorInterceptor<TApiError>[],
): AxiosInstance => {
    const client = axiosClientFactory.createDirectApiClient(
        {
            baseURL: `${trimTrailingSlash(appConfig.coopSettings.serviceAccess.extApimUrl)}/${externalLoyaltyAccountApiUrlPrefix}`,
            params: {
                'api-version': 'v1',
            },
            headers: {
                Accept: 'application/json',
                'Ocp-Apim-Trace': 'true',
                'Ocp-Apim-Subscription-Key':
                    appConfig.coopSettings.serviceAccess.extApimSubscriptionKey,
                Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
            },
        },
        errorInterceptors,
    );
    return client;
};

export default getDirectLoyaltyAxiosClient;
